import styled from 'styled-components'

export const FormContainer = styled.div``

export const FieldError = styled.p`
  color: #f1416c;
  font-size: 0.9rem;
  margin-top: 0.35rem;
  margin-bottom: 0;
`
